var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"location-stars"},[_c('div',{staticClass:"location-stars--active",style:({ width: ((_vm.value * 20) + "%") })})])}
var staticRenderFns = []

export { render, staticRenderFns }